import "./style.css";
import 'leaflet/dist/leaflet.css';
import 'leaflet.wms';

import "./i18n.js";
import { router, createNavigation, createFooter } from "./router.js";
import { initializeHeader } from "./components/Header.js";
import { PrivacyPage } from "./components/PrivacyPage.js";
import { HomePage } from "./components/HomePage.js";
import { BookEPCPage, initializeBookingPage } from "./components/BookEPCPage.js";
import { ImprovementsReportPage } from "./components/ImprovementsReportPage.js";
import { FaqPage } from "./components/FaqPage.js";
import { FaqInfoPage } from "./components/FaqInfoPage.js";
import { FaqCustomerPage } from "./components/FaqCustomerPage.js";
import { FaqCustomerInfoPage } from "./components/FaqCustomerInfoPage.js";
import { HowItWorksPage } from "./components/HowItWorksPage.js";
import { DocumentsNeededPage } from "./components/DocumentsNeededPage.js";
import { ContactPage } from "./components/ContactPage.js";
import { BlogPage, initializeNewsletterForm } from "./components/BlogPage.js";
import { aboutPage } from "./components/AboutPage.js";
import { ComparePage, initializeComparePage } from './components/ComparePage.js';
import { ComparePagePost, initializeComparePagePost } from './components/ComparePagePost.js';
import { TermsOfServicePage } from "./components/TermsOfServicePage.js";
 
import { CookiePage } from "./components/CookiePage.js";
import { WhyPage } from "./components/WhyPage.js";
import { KadasterPage, initializeKadasterPage } from "./components/KadasterPage.js";
import { AdvisorsPage } from "./components/AdvisorsPage.js";
import { EPCPage } from "./components/EPCPage.js";
import { EPCInfoPage } from "./components/EPCInfoPage.js";
 
// ------------------------------
// 🔹 admin portaal 
// ------------------------------
import { adminDashboard, initAdminDashboard } from "./components/js/adminDashboard.js";
import { dashboardlogin, initDashboardLoginLogic } from "./components/js/login.js";
import { adminDashboardLogin, initAdminDashboardLoginLogic } from "./components/js/adminlogin.js";
import { dashboardPage, initDashboard } from "./components/js/dashboard.js";
import { CadastroForm, initializeCadastroForm } from './components/CadastroForm.js';
import { RegisterPage } from './components/RegisterPage.js';
import { AppCadastro } from './components/app-cadastro.js';
 

 
// ------------------------------
// 🔹 API Base URL (switch automatisch tussen dev en productie)
// ------------------------------
const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost:4000/api"
    : "/api";


// Note: don't render the kadaster UI or initialize it globally here.
// The `KadasterPage` component renders `PropertyKadaster()` and calls
// `initializeKadaster()` when the page is actually shown via the router.

// Suppress expected console noise (errors, warnings, violations)
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

console.error = function (...args) {
  const message = args.join(" ");

  const suppressPatterns = [
    "net::ERR_FAILED",
    "403 (Forbidden)",
    "ut-unidades-administrativas.ign.es",
    "CORS policy",
    "Failed to fetch",
    "NetworkError",
    "Access to fetch at",
    "maps.aspx?test=",
    "google.com/web/",
  ];

  const shouldSuppress = suppressPatterns.some((pattern) =>
    message.includes(pattern),
  );

  if (!shouldSuppress) {
    originalConsoleError.apply(console, args);
  }
};

console.warn = function (...args) {
  const message = args.join(" ");

  const suppressWarnings = [
    "Added non-passive event listener",
    "[Violation] Avoid using",
    "document.write()",
    "maps.aspx?test=",
    "google.com/web/",
    "passive event listener",
  ];

  const shouldSuppress = suppressWarnings.some((pattern) =>
    message.includes(pattern),
  );

  if (!shouldSuppress) {
    originalConsoleWarn.apply(console, args);
  }
};

// ------------------------------
// 🔹 Kadaster API helpers
// ------------------------------

// Initialize the app structure
function initApp() {
  const app = document.querySelector("#app");
  if (!app) {
    console.warn(
      "initApp: #app element not found; skipping application initialization.",
    );
    return;
  }

  // Create the main layout
  app.innerHTML = `
    ${createNavigation()}
    <main id="main-content">
      <!-- Content will be loaded here -->
    </main>
    ${createFooter()}
  `;

  // Get the main content container
  const mainContent = document.querySelector("#main-content");

  // Define routes

 


  router.addRoute("/", async () => {
    mainContent.innerHTML = await HomePage();
    updateActiveNav("/");
    // (initializeHomePage verwijderd, niet meer nodig)
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/book-epc/", () => {
    mainContent.innerHTML = BookEPCPage();
    updateActiveNav("/book-epc/");
    
    // Initialize BookEPC page functionality
    setTimeout(() => {
      initializeBookingPage();
      window.i18n?.updatePageTexts();
    }, 0);
  });

  router.addRoute("/how-it-works/", () => {
    mainContent.innerHTML = HowItWorksPage();
    updateActiveNav("/how-it-works/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/improvements-report/", () => {
    mainContent.innerHTML = ImprovementsReportPage();
    updateActiveNav("/improvements-report/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });
  
    router.addRoute("/register/", () => {
    mainContent.innerHTML = RegisterPage();
    updateActiveNav("/register/");
    // Koppel submit-handler aan formulier
    setTimeout(() => {
      window.i18n?.updatePageTexts();
      // Zorg dat de DOM klaar is
      import('./components/RegisterPage.js').then(mod => {
        mod.initializeRegisterPage();
      });
    }, 0);
  });

  router.addRoute("/faq/", () => {
    mainContent.innerHTML = FaqPage();
    updateActiveNav("/faq/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/faq/info/", () => {
    mainContent.innerHTML = FaqInfoPage();
    updateActiveNav("/faq/info/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/faq-customer/", () => {
    mainContent.innerHTML = FaqCustomerPage();
    updateActiveNav("/faq-customer/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/faq-customer/info/", () => {
    mainContent.innerHTML = FaqCustomerInfoPage();
    updateActiveNav("/faq-customer/info/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });



  router.addRoute("/epc/", () => {
    mainContent.innerHTML = EPCPage();
    updateActiveNav("/epc/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

    router.addRoute("/epc/info/", () => {
    mainContent.innerHTML = EPCInfoPage();
    updateActiveNav("/epc/info/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/documents-needed/", () => {
    mainContent.innerHTML = DocumentsNeededPage();
    updateActiveNav("/documents-needed/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });


    router.addRoute("/cadastro/", () => {
    (async () => {
      mainContent.innerHTML = await KadasterPage();
      updateActiveNav("/cadastro/");
      // Initialize the cadastro form functionality
      initializeKadasterPage();
      // Update translations after content is loaded
      setTimeout(() => window.i18n?.updatePageTexts(), 0);
    })();
  });


      router.addRoute("/postal/", () => {
    (async () => {
      // Use CodigopostalPage for /postal/ route
      const { CodigopostalPage } = await import("./components/CodigopostalPage.js");
      mainContent.innerHTML = CodigopostalPage();
      updateActiveNav("/postal/");
      // Update translations after content is loaded
      setTimeout(() => window.i18n?.updatePageTexts(), 0);
    })();
  });

  router.addRoute("/about/", () => {
    mainContent.innerHTML = aboutPage();
    updateActiveNav("/about/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });


  router.addRoute("/why/", () => {
    mainContent.innerHTML = WhyPage();
    updateActiveNav("/why/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/advisors/", () => {
    mainContent.innerHTML = AdvisorsPage();
    updateActiveNav("/advisors/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/contact/", () => {
    mainContent.innerHTML = ContactPage();
    updateActiveNav("/contact/");
    // Koppel submit-handler aan formulier via dynamische import
    setTimeout(() => {
      window.i18n?.updatePageTexts();
      import('./components/ContactPage.js').then(mod => {
        mod.initializeContactForm(API_BASE);
      });
    }, 0);
  });

  router.addRoute("/compare/", () => {
    // (resetComparePageInitialization verwijderd, niet meer nodig)
    
    mainContent.innerHTML = ComparePage();
    updateActiveNav("/compare/");
    
    // Initialize ComparePage functionality after DOM is ready
    setTimeout(() => {
      initializeComparePage();
      // Update translations after content is loaded
      window.i18n?.updatePageTexts();
    }, 100);
  });

    router.addRoute("/comparepost/", () => {
    // (resetComparePageInitialization verwijderd, niet meer nodig)
    
    mainContent.innerHTML = ComparePagePost();
    updateActiveNav("/comparepost/");
    
    // Initialize ComparePage functionality after DOM is ready
    setTimeout(() => {
      initializeComparePagePost();
      // Update translations after content is loaded
      window.i18n?.updatePageTexts();
    }, 100);
  });

  router.addRoute("/privacy/", () => {
    mainContent.innerHTML = PrivacyPage();
    updateActiveNav("/privacy/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

    router.addRoute("/cookies/", () => {
    mainContent.innerHTML = CookiePage();
    updateActiveNav("/cookies/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  router.addRoute("/termsofservice/", () => {
    mainContent.innerHTML = TermsOfServicePage();
    updateActiveNav("/termsofservice/");
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

router.addRoute("/blog/", () => {
  window.open("https://blog.ceecasasespana.com/es/", "_self");
});


// Setup contact form functionality


// ------------------------------
// 🔹 admin portaal 
// ------------------------------

        router.addRoute("/portaal/adminDashboard/", async () => {
          mainContent.innerHTML = adminDashboard();
          initAdminDashboard();
          updateActiveNav("/portaal/adminDashboard/");
          setTimeout(() => window.i18n?.updatePageTexts(), 0);
        });
  router.addRoute("/portaal/adminlogin/", async () => {
    mainContent.innerHTML = adminDashboardLogin();
    initAdminDashboardLoginLogic();
    updateActiveNav("/portaal/adminlogin/");
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });
  router.addRoute("/portaal/dashboard/", async () => {
    mainContent.innerHTML = dashboardPage();
    initDashboard();
    updateActiveNav("/portaal/dashboard/");
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });
  router.addRoute("/portaal/login/", async () => {
    mainContent.innerHTML = dashboardlogin();
    initDashboardLoginLogic();
    updateActiveNav("/portaal/login/");
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });
  router.addRoute("/404", () => {
    mainContent.innerHTML = `
      <div class="error-page">
        <div class="container">
          <h1>404 - Página no encontrada</h1>
          <p>La página que buscas no existe.</p>
          <button class="btn btn-primary" data-route="/">Volver al Inicio</button>
        </div>
      </div>
    `;
    // Update translations after content is loaded
    setTimeout(() => window.i18n?.updatePageTexts(), 0);
  });

  // Handle initial route
  router.handleRoute();
  // Ensure fragments are handled on initial load
  scrollToHash();

  // Initialize header functionality (language selector)
  initializeHeader();
}

// Smoothly scroll to the element specified in the URL hash (if any).
function scrollToHash() {
  const hash = window.location.hash;
  if (!hash) return;
  // small delay to ensure route content has rendered
  setTimeout(() => {
    const target = document.querySelector(hash);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 50);
}

// Listen for client-side route changes and scroll to fragment if present
document.addEventListener("routeChanged", () => scrollToHash());

// Update active navigation item
function updateActiveNav(currentPath) {
  document.querySelectorAll(".nav-link").forEach((link) => {
    link.classList.remove("active");
    if (link.getAttribute("data-route") === currentPath) {
      link.classList.add("active");
    }
  });
}



// Initialize app

// Setup booking form functionality
function setupBookingForm() {
  const form = document.querySelector("#epc-booking-form");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      // Here you would normally send the form data to your backend
      alert("Formulario enviado correctamente. Te contactaremos pronto.");
    });
  }
}

// Setup FAQ functionality
function setupFAQ() {
  // FAQ toggle functionality
  document.querySelectorAll(".faq-question").forEach((question) => {
    question.addEventListener("click", () => {
      const item = question.parentNode;
      const answer = item.querySelector(".faq-answer");
      const toggle = question.querySelector(".toggle");

      if (answer.classList.contains("hidden")) {
        answer.classList.remove("hidden");
        toggle.textContent = "-";
      } else {
        answer.classList.add("hidden");
        toggle.textContent = "+";
      }
    });
  });

  // Category tabs functionality
  document.querySelectorAll(".tab-btn").forEach((tab) => {
    tab.addEventListener("click", () => {
      const category = tab.dataset.category;

      // Update active tab
      document
        .querySelectorAll(".tab-btn")
        .forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      // Show corresponding category
      document.querySelectorAll(".faq-category").forEach((cat) => {
        cat.classList.remove("active");
        if (cat.dataset.category === category) {
          cat.classList.add("active");
        }
      });
    });
  });
}

// Setup contact form functionality

// Suppress network errors for external resources
window.addEventListener("error", function (e) {
  const suppressErrors = [
    "ut-unidades-administrativas.ign.es",
    "juntadeandalucia.es",
    "sedecatastro.gob.es",
  ];

  if (
    suppressErrors.some(
      (domain) => e.message?.includes(domain) || e.filename?.includes(domain),
    )
  ) {
    e.preventDefault();
    return false;
  }
});

// Suppress unhandled promise rejections for external APIs
window.addEventListener("unhandledrejection", function (e) {
  const message = e.reason?.message || e.reason?.toString() || "";
  const suppressPatterns = [
    "Failed to fetch",
    "NetworkError",
    "CORS",
    "403",
    "404",
  ];

  if (suppressPatterns.some((pattern) => message.includes(pattern))) {
    e.preventDefault();
    return false;
  }
});

async function fetchAdvisors() {
  try {
    const res = await fetch(`${API_BASE}/advisors`, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'include',
    });
    if (!res.ok) {
      let errorMsg = 'Kon /api/companies niet laden';
      try {
        const errData = await res.json();
        errorMsg = errData.error || errorMsg;
      } catch {}
      throw new Error(errorMsg);
    }
    return await res.json();
  } catch (e) {
    throw new Error(e.message || 'Kon /api/companies niet laden');
  }
}

async function loadProvinciasCard() {
  const provinceSelect = document.querySelector("#province-card");
  if (!provinceSelect) return; // nothing to do on pages without the province select

  try {
    const data = await fetchAdvisors();
    const provinces = [...new Set(data.map((a) => a.province).filter(Boolean))];

    provinceSelect.innerHTML =
      '<option value="">Selecteer provincie</option>' +
      provinces.map((p) => `<option value="${p}">${p}</option>`).join("");
  } catch (err) {
    // loadProvinciasCard: failed to load provinces
    // keep the select as-is (or show a single disabled option)
    provinceSelect.innerHTML =
      '<option value="">Kon provincies niet laden</option>';
  }
}

async function loadCitiesCard(province) {
  const citySelect = document.querySelector("#city-card");
  if (!citySelect) return;
  citySelect.disabled = true;
  citySelect.innerHTML = "<option>Laden...</option>";

  try {
    const data = await fetchAdvisors();
    const cities = [
      ...new Set(
        data
          .filter((a) => a.province === province)
          .map((a) => a.city)
          .filter(Boolean),
      ),
    ];

    citySelect.innerHTML =
      '<option value="">Selecteer plaats</option>' +
      cities.map((c) => `<option value="${c}">${c}</option>`).join("");
    citySelect.disabled = false;
  } catch (err) {
    // loadCitiesCard: failed to load cities
    citySelect.innerHTML = '<option value="">Kon plaatsen niet laden</option>';
    citySelect.disabled = true;
  }
}

async function filterAdvisors() {
  const provinceEl = document.querySelector("#province-card");
  const cityEl = document.querySelector("#city-card");
  const buildingEl = document.querySelector("#building-type-card");
  const listEl = document.querySelector("#list");

  const province = provinceEl ? provinceEl.value : "";
  const city = cityEl ? cityEl.value : "";
  const buildingType = buildingEl ? buildingEl.value : "";
  if (!listEl) return;

  listEl.textContent = "Laden...";
  const data = await fetchAdvisors();

  const filtered = data.filter(
    (a) => (!province || a.province === province) && (!city || a.city === city),
  );

  if (filtered.length === 0) {
    listEl.textContent =
      "No se encontraron asesores para los filtros seleccionados.";
    return;
  }

  listEl.innerHTML = filtered
    .map(
      (row) => `
    <article class="border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
      <strong>${row.name || ""}</strong> — ${row.company || ""}
      <div class="text-gray-600">${row.province || ""} • ${row.city || ""}</div>
      <div>⭐ ${row.rating ?? "—"} (${row.ratingCount ?? 0})</div>
      <small class="block text-sm text-gray-500 mt-1">
        Appartement: €${row.apartmentPrice ?? "—"} · 
        Huis: €${row.housePrice ?? "—"} · 
        Commercieel: €${row.comercialPrice ?? "—"} · 
        Tussenwoning: €${row.tussenwoningPrice ?? "—"}
      </small>
    </article>
  `,
    )
    .join("");
}

// Initialisatie
document.addEventListener("DOMContentLoaded", async () => {
  const provinceSelect = document.querySelector("#province-card");
  if (provinceSelect) {
    await loadProvinciasCard();
    provinceSelect.addEventListener("change", (e) => {
      const province = e.target.value;
      if (province) loadCitiesCard(province);
      else {
        const citySelect = document.querySelector("#city-card");
        if (citySelect) {
          citySelect.innerHTML = '<option value="">Selecteer plaats</option>';
          citySelect.disabled = true;
        }
      }
    });
  }

  const updateBtn = document.querySelector("#update-card");
  if (updateBtn) updateBtn.addEventListener("click", filterAdvisors);
});

function setupAdvisorDatabaseIntegration() {
  const formEl = document.getElementById("partner-registration-form");
  if (!formEl) return; // Only run if form exists

  formEl.addEventListener("submit", async (e) => {
    e.preventDefault();
    const form = new FormData(formEl);

    // Map all form fields to database structure
    const payload = {
      name: form.get("name"),
      company: form.get("company"),
      services: form.get("services"),
      software: form.get("software"),
      description: form.get("description"),
      province: form.get("province"),
      city: form.get("city"),
      phone: form.get("phone"),
      email: form.get("email"),
      website: form.get("website"),
      logo: form.get("logo"),
      address: form.get("address"),
      role: form.get("role"),
      apartmentPrice: form.get("apartmentPrice")
        ? Number(form.get("apartmentPrice"))
        : null,
      housePrice: form.get("housePrice")
        ? Number(form.get("housePrice"))
        : null,
      comercialPrice: form.get("comercialPrice")
        ? Number(form.get("comercialPrice"))
        : null,
      tussenwoningPrice: form.get("tussenwoningPrice")
        ? Number(form.get("tussenwoningPrice"))
        : null,
      rating: form.get("rating") ? Number(form.get("rating")) : 5.0,
      ratingCount: form.get("ratingCount")
        ? Number(form.get("ratingCount"))
        : 0,
    };

    try {
      const res = await fetch(`${API_BASE}/advisors`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: 'include',
      });

      if (!res.ok) throw new Error("Server error " + res.status);

      // Show success message
      alert("¡Registro de socio enviado con éxito!");
      formEl.reset();

      // Reload advisor list if it exists
      await loadAdvisors();
    } catch (err) {
      console.error("Database error:", err);
      alert("Fout bij opslaan: " + err.message);
    }
  });
}

// Make functions available globally for router callbacks

// Load advisors and update the advisor list (used after registration or updates)
async function loadAdvisors() {
  const listEl = document.querySelector("#list");
  if (!listEl) return;
  listEl.textContent = "Laden...";
  try {
    const data = await fetchAdvisors();
    if (!Array.isArray(data) || data.length === 0) {
      listEl.textContent = "No se encontraron asesores.";
      return;
    }
    listEl.innerHTML = data
      .map(
        (row) => `
      <article class="border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
        <strong>${row.name || ""}</strong> — ${row.company || ""}
        <div class="text-gray-600">${row.province || ""} • ${row.city || ""}</div>
        <div>⭐ ${row.rating ?? "—"} (${row.ratingCount ?? 0})</div>
        <small class="block text-sm text-gray-500 mt-1">
          Appartement: €${row.apartmentPrice ?? "—"} · 
          Huis: €${row.housePrice ?? "—"} · 
          Commercieel: €${row.comercialPrice ?? "—"} · 
          Tussenwoning: €${row.tussenwoningPrice ?? "—"}
        </small>
      </article>
    `,
      )
      .join("");
  } catch (err) {
    listEl.textContent = "Error al cargar asesores.";
    console.error("loadAdvisors error:", err);
  }
}

window.loadAdvisors = loadAdvisors;
window.setupAdvisorDatabaseIntegration = setupAdvisorDatabaseIntegration;

// Initialize the application
document.addEventListener("DOMContentLoaded", initApp);
